import {bindActionCreators} from 'redux'

import {getManagementAssignmentsSelection, getPanelUserFML, getTab, isCopyLoading, isShowCopyContent} from '../selectors'
import {connect} from '../../../../redux/utils'
import ManagementAssignmentsPanelContent from '../../managementAssignmentsPanel/ManagementAssignmentsPanelContent'
import {changeAssignmentPanelTab, changeManagementAssignmentsSelection, closePanel, showCopyContent} from '../actions'
import {openEditor} from '../../managementAssignmentsEditor/actions'
import TabContent from './TabContent'
import {getManagementAssignmentsCounters} from '../../../../panels/user/userData/selectors'

class EditManagementAssignmentsPanelContent extends ManagementAssignmentsPanelContent {
    constructor(params) {
        const tabContent = new TabContent()

        super({
            ...params,
            tabContent: tabContent,
        })
    }
}


export default connect(
    state => ({
        managementAssignmentsSelection: getManagementAssignmentsSelection(state),
        userFML: getPanelUserFML(state),
        counters: getManagementAssignmentsCounters(state),
        openTab: getTab(state),
        showCopyContent: isShowCopyContent(state),
        copyContentLoading: isCopyLoading(state),
    }),
    dispatch => ({
        onManagementAssignmentsSelectionChange: bindActionCreators(changeManagementAssignmentsSelection, dispatch),
        openEditorPanel: bindActionCreators(openEditor, dispatch),
        onPanelHide: bindActionCreators(closePanel, dispatch),
        onTabChanged: bindActionCreators(changeAssignmentPanelTab, dispatch),
        onCopyFromButtonClick: bindActionCreators(showCopyContent, dispatch),
    })
)(EditManagementAssignmentsPanelContent)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/components/ManagementAssignmentsPanelContent.js